import { Row, Col, Badge } from 'react-bootstrap';
import TeamCompetitionSesionResultTableContainer from './team-competition-sesion-result-table-container';
import TeamCompetitionCompetitorsContainer from './team-competition-competitors-container';
import type { TeamCompetition } from '../types/api.types';

interface TeamCompetitionOverviewProps {
  teamComp: TeamCompetition | undefined | null;
}

export default function TeamCompetitionOverview({ teamComp }: TeamCompetitionOverviewProps) {
  if (teamComp === undefined || teamComp === null) {
    return null;
  }

  const cupWinner =
    teamComp.winner == null ? null : (
      <Badge className={teamComp.winner === 'EUR' ? 'team-eur' : 'team-usa'}>
        {teamComp.winner === 'EUR' ? 'Europe' : 'USA'}
        {/* TODO: Add retained property to TeamCompetition type if needed */}
        {' Win'}
      </Badge>
    );

  return (
    <div>
      <Row>
        <Col md={12}>
          <h3>
            <span>Ryd-Her Cup </span>
            {cupWinner != null ? cupWinner : null}
          </h3>
        </Col>
      </Row>
      <TeamCompetitionSesionResultTableContainer teamCompID={teamComp.id} />
      <TeamCompetitionCompetitorsContainer teamCompID={teamComp.id} />
    </div>
  );
}
